<template lang="pug">
    .footer
        .pc
            img.logo(src="@/assets/img/foot_logo.png")
            .copyright
                .text Copyright © 2009-2021 dragonrisecapital All rights reserved.
                .btn 法律声明
</template>

<script>
export default {
    
}
</script>

<style lang="sass" scoped>
.footer
    background: #313131
    height: 100px
    width: 100%
    box-sizing: border-box
    .pc
        height: 100%
        margin: 0 auto
        display: flex
        justify-content: center
        align-items: center
        .logo
            width: 240px
            display: none
        .copyright
            color: #fff
            font-size: 12px
            text-align: center
            .text 
                line-height: 2
            .btn
                display: inline-block
                border-radius: 100px
                padding: 0.2em 1em
                background: rgba(255, 255, 255, 0.3)
@media screen and (min-width: 1024px)
    .footer
        background: #313131
        height: 196px
        width: 100%
        box-sizing: border-box
        .pc
            max-width: 1000px
            height: 100%
            margin: 0 auto
            display: flex
            justify-content: space-between
            align-items: center
            .logo
                width: 240px
                display: block
            .copyright
                color: #fff
                font-size: 12px
                text-align: right
                .text 
                    line-height: 2
                .btn
                    display: inline-block
                    border-radius: 100px
                    padding: 0.2em 1em
                    background: rgba(255, 255, 255, 0.3)
</style>